import { IconSize } from './Icon.types';

export const SIZE_MAP: Record<IconSize, number> = {
  md: 24,
  sm: 18,
};
